<template>
    <CModal
        :title="titleComponent"
        :show="showComponent"
        :color="colorComponent"
        :size="sizeComponent"
    >
        <CForm ref="formAddSubTag" @submit="submitForm($event, 'addSubTag')">
            <CInput
                :isValid="checkIfFormValid({
                    formName:'addSubTag',
                    fieldName:'name'
                })"
                :placeholder="$t('enter_a_name')"
                :value.sync="$v.forms.addSubTag.name.$model"
                :label="$t('name')"
            />

            <CInput
                :isValid="checkIfFormValid({
                    formName:'addSubTag',
                    fieldName:'code'
                })"
                :placeholder="$t('enter_a_code')"
                :value.sync="$v.forms.addSubTag.code.$model"
                :label="$t('code')"

            />

            <ButtonLoading
                type="submit"
                :block="true"
                color="primary"
                :loading="forms.addSubTag._loading"
            >
                <span>{{ $t('add_sub_tag') }}</span>
            </ButtonLoading>

        </CForm>
        <template #footer>
            <CButton color="secondary" @click="closeModal()">
                {{ $t("cancel") }}
            </CButton>
            <ButtonLoading color="success" @click="executeSubmitForm" :loading="forms.addSubTag._loading">
                {{ $t("add_sub_tag") }}
            </ButtonLoading>
        </template>
    </CModal>
</template>

<script>
/** Components */
import ButtonLoading from '~/components/ButtonLoading.vue';

/** Mixins */
import formMixin from '~/mixins/form';
import modalComponentMixin from '~/mixins/modalComponent';

/** Others */
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators"
export default {
    name: "AddSubTagModal",
    mixins: [
        formMixin, 
        validationMixin,
        modalComponentMixin
    ],
    components: {
        ButtonLoading
    },
    data(){
        return {
            forms:{
                addSubTag:{
                    name: null,
                    code:null,
                    tagUuid:null,
                    _loading: false
                },
            }
        }
    },
    validations:{
        forms:{
            addSubTag:{
                name:{
                    required
                },
                code:{
                    required
                }
            }
        }
    },

    watch:{
        show(){
            this.showComponent = this.show;
            if(!this.show){
                this.resetForms();
                this.$v.$reset();
            }
        },
        dataComponent(){
            if(this.dataComponent.tagUuid)
                this.forms.addSubTag.tagUuid = this.dataComponent.tagUuid;
        }
    },

    methods:{
        async submitForm(e, formName){
            e.preventDefault();
            await this.sendForm({ 
                formName , 
                url: '/sub-tags',
                fetch:{
                    baseURL: process.env.VUE_APP_API_CORE,
                }
            });
            this.showComponent = false;
            console.log("Enter here");
            this.$emit('submit',formName);
        }
    }
};
</script>

<style>
</style>